import { cn } from '@/shared/utils/utils'
import { Modal } from 'antd'

import './style.scss'

// ponytail: styled(Modal) cũ không còn rule CSS nào (toàn bộ đã comment) — bọc thừa qua
// styled-components v6 dưới React 19 nghi làm gãy ref-forward mà rc-motion cần để biết đóng
// animation xong (modal bấm OK/Cancel không tắt). Dùng thẳng antd Modal, không mất style nào.
export default function CustomModal(props: any) {
  const { children, className, hiddenScroll, testId, ...rest } = props

  // testId KHÔNG có giá trị mặc định: antd giữ portal của modal đã đóng lại trong DOM, và một
  // màn có thể mount tới 4 CustomModal cùng lúc (xem ProductSupplyChainListContainer) — một
  // testid dùng chung sẽ khớp nhiều node và làm Playwright báo strict-mode violation.
  return (
    <Modal
      width={1024}
      style={{ top: 120 }}
      {...rest}
      data-testid={testId}
      className={cn(className)}
    >
      {children}
    </Modal>
  )
}
